import { LeadStageCheckboxSelect } from "../../lead_stage/LeadStageCheckboxSelect";
import { LeadFilterContentProps, StyledFilterContent } from "./utils";

function StageFilterContent({ control }: LeadFilterContentProps) {
  return (
    <StyledFilterContent aria-label="Stage filter">
      <LeadStageCheckboxSelect control={control} />
    </StyledFilterContent>
  );
}

export default StageFilterContent;
